/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useEffect, useContext, useState } from 'react';
import React from 'react';
import { WsContext, WsContextType } from './WsContext';

ChartJS.register(       // keep unused stuff out of webpack
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const LivePlotInner = () => {
    const wsContext = useContext(WsContext) as WsContextType;
    const [data, setData] = useState<any>(null);

    const handlers = {
        livePlot: (msg: any) => {
            if (!msg) {
                return;
            }
            setData(msg);
        }
    };

    useEffect(() => {
        if (!wsContext.ws) {
            return;
        }
        wsContext.ws.on('livePlot', handlers.livePlot);
        return () => {
            wsContext.ws.off('livePlot', handlers.livePlot);
        }   
    }, [ wsContext ]);

    if (!data) {
        return null;
    }
    const options = {
        responsive: true,
        scales: {
            y: {
                min: 0, max: 100
            },
            x: {
                type: 'linear',
            },
        },
        plugins: {
            legend: {
                display: false,
            }
        },
        animations: {
            y: { 
                duration: 0,
            }
        }
    };

    // @ts-ignore
    /*
    const chartData = {
      ...data,
      datasets: data.datasets.map(dataset => ({
        ...dataset,
        borderColor: 'white',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        pointBackgroundColor: 'white',
        pointBorderColor: 'white'
      }))
    };
    */
    
    // @ts-ignore
    return <Line data={data} options={options} />;
};

export const LivePlot = React.memo(LivePlotInner);